import { resolveImagePath } from '@/utils/imageResolver';

export interface HeroProps {
  headline: string;
  logoUrl?: string;
  videoSrc?: string;
  videoPoster?: string;
}

export function Hero({ 
  headline = "Elevate Your Experience in the Skies",
  logoUrl,
  videoSrc,
  videoPoster
}: HeroProps) {
  const logoSrc = logoUrl ? resolveImagePath(logoUrl) : resolveImagePath('/images/Crystal-Air_Logo_White-Blue.svg');

  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full">
        <video
          autoPlay
          loop
          muted
          playsInline
          poster={videoPoster}
          className="w-full h-full object-cover"
        >
          {videoSrc && (
            <>
              <source src={videoSrc.replace('.mp4', '.webm')} type="video/webm" />
              <source src={videoSrc} type="video/mp4" />
            </>
          )}
        </video>
        
        {/* Overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-30" />
      </div>

      {/* Content Overlay */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center text-white">
        <div className="max-w-4xl mx-auto">
          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight">
            {headline}
          </h1>
          
          {/* Logo */}
          <div className="mt-12">
            <img
              src={logoSrc}
              alt="Crystal Air Logo"
              className="h-20 md:h-24 lg:h-32 mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}